function getFilename(urlString) {
  const url = new URL(urlString);
  const pathname = url.pathname.split('/');

  return pathname[pathname.length - 1];
}

export { getFilename };
